function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconFacebookSquare = function IconFacebookSquare(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 33",
    fill: "none",
    stroke: "none",
    role: "img",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "m3.2048 0.075195c-1.767 0-3.1995 1.4324-3.1995 3.1995v25.601c0 1.767 1.4324 3.1995 3.1995 3.1995h25.601c1.767 0 3.1995-1.4325 3.1995-3.1995v-25.601c0-1.767-1.4325-3.1995-3.1995-3.1995h-25.601zm6.1374 18.013h3.6694v10.062h4.3591v-10.062h3.2213l0.6471-4.0675h-3.8684v-3.072c0-1.1378 1.0951-1.7849 2.1333-1.7849h1.8845v-3.3707l-3.3707-0.14934c-3.2213-0.19911-5.0062 2.3324-5.0062 5.3546v3.0223h-3.6694v4.0675z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconFacebookSquare));
//# sourceMappingURL=IconFacebookSquare.js.map